import type { CatalogOtherCostVariableItemData, ProjectMethodologyEnum } from 'gql/graphql';

export enum CatalogVariablesOtherTab {
    Global = 'global',
    Local = 'local',
}

export type CatalogVariablesOtherTabItem = {
    id: CatalogVariablesOtherTab;
    label: string;
};

export type CatalogVariablesOtherMethodologyItem = {
    label: string;
    value: ProjectMethodologyEnum;
};

export type CatalogVariablesOtherRow = CatalogOtherCostVariableItemData;
